import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import client from '@/lib/api';
import { useToast } from '@/hooks/use-toast';
import { Loader2 } from 'lucide-react';

export default function ForgotPasswordPage() {
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await client.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      toast({ title: 'Something went wrong', description: err?.response?.data?.detail || 'Try again.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-[80vh] flex items-center">
      <div className="absolute inset-0 viso-grid opacity-30" />
      <div className="relative w-full max-w-md mx-auto px-6">
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-8">
          <div className="text-xs font-mono uppercase tracking-widest text-cyan-300 mb-3">Reset password</div>
          <h1 className="font-display text-3xl font-bold">Forgot your password?</h1>
          {sent ? (
            <p className="text-sm text-slate-300 mt-6">
              If <span className="text-cyan-300">{email}</span> has an account with us, we've sent a link to reset your password. It's valid for 1 hour.
            </p>
          ) : (
            <>
              <p className="text-sm text-slate-400 mt-2">Enter your account email and we'll send you a reset link.</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <Label className="text-slate-300">Company email</Label>
                  <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-black/30 border-white/10 mt-1" />
                </div>
                <Button disabled={loading} className="w-full bg-cyan-400 hover:bg-cyan-300 text-slate-900 font-medium">
                  {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Send reset link
                </Button>
              </form>
            </>
          )}
          <div className="mt-6 text-sm text-slate-400">
            <Link to="/login" className="hover:text-cyan-300">Back to log in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
